<template>
  <div class="overlay overlay--loader">
    <div class="loader--windows">
      <div class="loader__dot loader__dot--1"></div>
      <div class="loader__dot loader__dot--2"></div>
      <div class="loader__dot loader__dot--3"></div>
      <div class="loader__dot loader__dot--4"></div>
      <div class="loader__dot loader__dot--5"></div>
    </div>
  </div>
</template>
<script setup lang="ts"></script>